/**
 * @component BulkActions
 * @description
 * Componente que muestra un menú desplegable de acciones masivas para aplicar sobre los elementos seleccionados en una tabla.
 * Actualmente incluye opciones como "Eliminar", y un botón para aplicar la acción seleccionada.
 *
 * @example
 * <BulkActions />
 */

import React from 'react';
import { Button, Form } from 'react-bootstrap';

const BulkActions = () => (
    <div className="d-flex">
        <Form.Select size="sm" aria-label="Bulk actions">
            <option>Acciones</option>
            <option value="delete">Eliminar</option>
        </Form.Select>
        <Button type="button" variant="falcon-default" size="sm" className="ms-2">
            Aplicar
        </Button>
    </div>
);

export default BulkActions;